export default {
  primaryColor: "#f8866a",
  secondaryColor: "red"
};
